export interface AppointmentEvent {
  uid: string;
  title: string;
  /** `yyyyMMddHHmm`, the store's local time, as the timeslots API serializes it. */
  start: string;
  end: string;
  location?: string;
}

const escapeText = (value: string): string => value.replace(/[\\;,]/g, (char) => `\\${char}`);

export const toIcsDateTime = (value: string): string => `${value.slice(0, 8)}T${value.slice(8, 12)}00`;

/** Floating times, without zone: every calendar shows the hour the funnel showed. */
export function buildAppointmentIcs(event: AppointmentEvent, now: Date): string {
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    "PRODID:-//SoCoo'c//Rendez-vous//FR",
    'BEGIN:VEVENT',
    `UID:${event.uid}@socooc.com`,
    `DTSTAMP:${now.toISOString().replace(/[-:]/g, '').slice(0, 15)}Z`,
    `DTSTART:${toIcsDateTime(event.start)}`,
    `DTEND:${toIcsDateTime(event.end)}`,
    `SUMMARY:${escapeText(event.title)}`,
    ...(event.location ? [`LOCATION:${escapeText(event.location)}`] : []),
    'END:VEVENT',
    'END:VCALENDAR',
  ];
  return `${lines.join('\r\n')}\r\n`;
}
